import type { ExternalShippingCarrierAddress } from "@jti/commerce-types";
import { newrelic } from "@jti/fe-clients";

export const isExternalCarrierAddress = (address: unknown): address is ExternalShippingCarrierAddress => {
  const invalidFields: Array<keyof ExternalShippingCarrierAddress> = [];

  if (typeof address !== "object" || address === null) {
    newrelic.noticeError(new Error("custom shipping option address error: address is not an object"));
    return false;
  }

  const candidate = address as Partial<ExternalShippingCarrierAddress>;

  if (typeof candidate.storeId !== "string") {
    invalidFields.push("storeId");
  }

  if (typeof candidate.storeName !== "string") {
    invalidFields.push("storeName");
  }

  if (typeof candidate.city !== "string") {
    invalidFields.push("city");
  }

  if (typeof candidate.streetName !== "string") {
    invalidFields.push("streetName");
  }

  if (typeof candidate.streetNumber !== "string") {
    invalidFields.push("streetNumber");
  }

  if (typeof candidate.postCode !== "string") {
    invalidFields.push("postCode");
  }

  if (typeof candidate.countryCode !== "string") {
    invalidFields.push("countryCode");
  }

  if (candidate.phoneNumber && typeof candidate.phoneNumber !== "string") {
    invalidFields.push("phoneNumber");
  }

  if (
    candidate.location &&
    (typeof candidate.location.lat !== "number" || typeof candidate.location.lon !== "number")
  ) {
    invalidFields.push("location");
  }

  if (candidate.customData && typeof candidate.customData !== "object") {
    invalidFields.push("customData");
  }

  if (invalidFields.length === 0) {
    return true;
  }

  newrelic.noticeError(
    new Error(
      `custom shipping option address error. Invalid fields: ${invalidFields.join(
        ", "
      )}. Provided address: \n${JSON.stringify(address)}`
    )
  );

  return false;
};
